import { updatePerson } from '../../../services/resources/persons';

export function handleSubmit(
  values,
  { setSubmitting },
  { passenger, navigateNext, handleError, token, refetch }
) {
  const { signature } = values;

  const config = token
    ? {
        headers: { Authorization: `Bearer ${token}` },
      }
    : null;

  updatePerson({
    personId: passenger.person.id,
    values: {
      ...values,
      ...(signature && !passenger.person.is_minor ? { signature } : {}),
      ...(values?.country_id && { country: { id: values.country_id } }),
      ...(values?.country_of_birth_id && {
        countryOfBirth: { id: values?.country_of_birth_id },
      }),
    },
    config,
  })
    .then(async () => {
      setSubmitting(false);
      await refetch?.();
      navigateNext?.();
    })
    .catch(error => {
      handleError(error);
      setSubmitting(false);
    });
}
